import React from 'react';
import { Phone, CheckCircle2, MailCheck } from 'lucide-react';

const PHONE_DISPLAY = '(336) 354-1040';
const PHONE_LINK = 'tel:+13363541040';
const LOGO = 'https://customer-assets.emergentagent.com/job_rizzi-practice/artifacts/j5bpvf84_logo.png';

const CarAccidentThankYou = () => (
  <div className="min-h-screen flex flex-col font-body bg-slate-50" data-testid="thank-you-page">
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-[1180px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <img src={LOGO} alt="Rizzi Law Group" className="h-9 md:h-11 w-auto" style={{ imageRendering: '-webkit-optimize-contrast' }} />
        <a href={PHONE_LINK} className="flex items-center gap-2 text-primary font-extrabold text-[15px] md:text-[18px] hover:text-primary/80 transition-colors" data-testid="thankyou-call-link">
          <Phone className="h-4 w-4 md:h-5 md:w-5" /> {PHONE_DISPLAY}
        </a>
      </div>
    </header>

    <main className="flex-1 flex items-center justify-center px-4 py-16">
      <div className="bg-white rounded-2xl shadow-xl border border-slate-200 max-w-lg w-full p-8 sm:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="h-8 w-8 text-emerald-600" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mb-3">
          Thank you
        </h1>
        <p className="text-slate-600 text-base leading-relaxed mb-6">
          Your information has been received. A member of the Rizzi Law Group intake team may contact you
          shortly to review the details and discuss next steps.
        </p>

        <div className="flex items-start gap-3 text-left bg-slate-50 border border-slate-200 rounded-xl p-5 mb-6">
          <MailCheck className="h-6 w-6 text-primary flex-shrink-0 mt-0.5" />
          <p className="text-slate-700 text-[15px] leading-relaxed">
            If you started a document, a copy will be available by email. You can also reply to that email
            or call us anytime if you have questions before continuing.
          </p>
        </div>

        <a href={PHONE_LINK} className="inline-flex items-center gap-2 text-primary font-bold hover:underline" data-testid="thankyou-phone-cta">
          <Phone className="h-4 w-4" /> Questions? Call us at {PHONE_DISPLAY}
        </a>

        <p className="text-slate-400 text-[11px] mt-8 leading-relaxed">
          Submitting this form does not create an attorney-client relationship and does not guarantee case
          acceptance or compensation.
        </p>
      </div>
    </main>
  </div>
);

export default CarAccidentThankYou;
